import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'container-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainContainer implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
